import dayjs from "../utils/dayjs";

export default function useTime(time, format, rules) {
  if (!time) return null;
  const isUSA =
    JSON.parse(localStorage.getItem("user-localev2"))?.location
      ?.country_code === "US";
  if (format) {
    return dayjs(time).format(format);
  }
  if (rules) {
    return dayjs(time).format(isUSA ? rules.US : rules.default);
  }

  return dayjs(time).format(isUSA ? "HH:mm MM-DD-YY" : "HH:mm DD-MM-YY");
}
